import { render, staticRenderFns } from "./Twofa.vue?vue&type=template&id=4d7e6fce&scoped=true&"
import script from "./Twofa.vue?vue&type=script&lang=js&"
export * from "./Twofa.vue?vue&type=script&lang=js&"
import style0 from "./Twofa.vue?vue&type=style&index=0&id=4d7e6fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e6fce",
  null
  
)

export default component.exports